import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { ScanLineIcon } from 'lucide-react'

import { EmptyState } from '@ems/ui/patterns/empty-state'
import { PageHeader } from '@ems/ui/patterns/page-header'

import { sessionQuery } from '#admin/features/auth/queries.ts'
import { can } from '#admin/features/auth/session.ts'
import { CheckInStation } from '#admin/features/onsite/check-in-station.tsx'

/**
 * The check-in station at a door. On `onsite.write`, as `POST /v1/onsite/check-in` is: a door
 * steward checks people in, and needs no power to change the event.
 */
export const Route = createFileRoute('/_authenticated/ticketing/check-in')({
  staticData: { crumb: { parents: [{ label: 'Ticketing' }], label: 'Check-in desk' } },
  component: OnsitePage,
})

function OnsitePage() {
  const { data: session } = useSuspenseQuery(sessionQuery())
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Check-in desk"
        description="Scan a badge to let a person in. Each scan is recorded with this gate."
      />
      {can(session, 'onsite.write') ? (
        <CheckInStation />
      ) : (
        <EmptyState
          icon={<ScanLineIcon />}
          title="You cannot check people in"
          description="Ask an administrator for the onsite check-in permission."
        />
      )}
    </div>
  )
}
